import { Component } from '@angular/core';
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { ShareGroupView } from "@pages/shares/models/share-group-view";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

type CellRendererParams = ICellRendererParams<ShareGroupView>;

@Component({
  selector: 'app-ag-share-warning-tooltip',
  standalone: true,
  imports: [
    NgbTooltip,
  ],
  templateUrl: './ag-share-warning-tooltip.component.html',
  styleUrl: './ag-share-warning-tooltip.component.scss'
})
export class AgShareWarningTooltipComponent implements ICellRendererAngularComp {
  shareClass: string | null = null;
  issueMessage: string | null = null;
  hasIssue = false;

  agInit(params: CellRendererParams): void {
    this.updateCell(params);
  }

  refresh(params: CellRendererParams): boolean {
    return this.updateCell(params);
  }

  updateCell(params: CellRendererParams): boolean {
    const groupShareView = new ShareGroupView(params.data);

    this.shareClass = groupShareView.shareClass;
    this.hasIssue = groupShareView.hasIssue;
    this.issueMessage = groupShareView.issueMessage;

    return true;
  }
}
